import TCPill from '../TCPill';

import './TCNavPill.scss';

const TCNavPill = ({ balance, width = 20, height = 20 }) => (
  <div className="TCNavPill">
    <TCPill
      balance={balance}
      width={width}
      height={height}
    />
  </div>
);

export default TCNavPill;
